<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "registrationLayout",
};
</script>

<style scoped></style>
